import { filterDraftsAndEmptyObjectsFromTasks } from '../../hooks/useMissionControlPoolStateManagement'
import { IRootReducer } from '../../types/reducerTypes'

export const selectCurrentProject = ({ missionControl }: IRootReducer) =>
  missionControl.currentProject

export const selectProjectHasTasks = ({ missionControl }: IRootReducer) =>
  filterDraftsAndEmptyObjectsFromTasks(
    missionControl.currentProject?.tasks ?? [],
  ).length > 0

export const selectTaskSubmissions = ({ missionControl }: IRootReducer) =>
  missionControl.taskSubmissions

export const selectPointsRecords = ({ missionControl }: IRootReducer) =>
  missionControl.pointsRecords

export const selectXpRecords = ({ missionControl }: IRootReducer) =>
  missionControl.xpRecords

export const selectXpData = ({ missionControl }: IRootReducer) =>
  missionControl.xpData

export const selectHeaderXpData = ({ missionControl }: IRootReducer) =>
  missionControl.headerXpData

export const selectLeaderboard = ({ missionControl }: IRootReducer) =>
  missionControl.leaderboard

export const selectUserSlicedLeaderboard = ({ missionControl }: IRootReducer) =>
  missionControl.userSlicedLeaderboard

export const selectUserHasProject = ({ missionControl }: IRootReducer) =>
  missionControl.userHasProject

export const selectIsUserBlocked = ({ missionControl }: IRootReducer) =>
  missionControl.isUserBlocked

export const selectUserProjects = ({ missionControl }: IRootReducer) =>
  missionControl.userProjects

export const selectTaskToAnimate = ({ missionControl }: IRootReducer) =>
  missionControl.taskToAnimate

export const selectHasSignupBonus = ({ missionControl }: IRootReducer) =>
  missionControl.hasSignupBonus

export const selectTotalAllocation = ({ missionControl }: IRootReducer) =>
  missionControl.totalAllocation

export const selectTotalAllocationToAllParticipants = ({
  missionControl,
}: IRootReducer) => missionControl.totalAllocationToAllParticipants

export const selectExpectedRealAllocation = ({
  missionControl,
}: IRootReducer) => missionControl.expectedRealAllocation

export const selectPricePerToken = ({ missionControl }: IRootReducer) =>
  missionControl.pricePerToken
